import React, { useEffect, useState, useMemo } from 'react';
import { Drawer, List, Card, Tabs } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import {
  toggleHistory,
} from '../../slices/historySlice';
import {
  connectSocket,
  disconnectSocket,
  subscribeToOrganization,
} from '../../Helper/webSocketActions';
import './History.scss';
import store from '../../store';

const { TabPane } = Tabs;

const HistorySidebar = () => {
  const dispatch = useDispatch();
  const collapsed = useSelector(state => state.history.isCollapsed);
  const allEvents = useSelector(state => state.webSocket.events);
  const user = store.getState().auth.user;

  const [currentTab, setCurrentTab] = useState('all');

  // Memoized events for "Mine" tab to avoid recalculations on every render
  const myEvents = useMemo(() => {
    const userId = user?.userId
    return allEvents.filter(event => event.userId === userId);
  }, [allEvents]);

  useEffect(() => {
    dispatch(connectSocket());
    const tenantId = user?.tenantId;
    dispatch(subscribeToOrganization(tenantId));
    return () => {
      dispatch(disconnectSocket());
    };
  }, [dispatch]);

  const handleTabChange = key => {
    setCurrentTab(key);
  };

  const handleDrawerClose = () => {
    dispatch(toggleHistory());
  };

  const getStatusColor = status =>
    status === 'SUCCESSFUL' ? '#52c41a' : '#ff4d4f';

  const renderEventCard = item => (
    <Card
      style={{
        width: '100%',
        borderLeft: `4px solid ${getStatusColor(item.status)}`,
        fontSize: '13px'
      }}
    >
      <div>
        <strong>
          {item.labelId} » {item.eventId} » {item.action}
        </strong>
      </div>
      <div>{item.status}</div>
      <div>{item.timestamp}</div>
    </Card>
  );

  return (
    <Drawer
      title="Eventverlauf"
      width={300}
      closable={true}
      onClose={handleDrawerClose}
      open={collapsed}
    >
      <Tabs
        activeKey={currentTab}
        onChange={handleTabChange}
        className="custom-tabs"
        size="large"
      >
        <TabPane
          tab={<div style={{ width: '100%', textAlign: 'center' }}>Alle</div>}
          key="all"
        >
          <List
            dataSource={allEvents}
            renderItem={item => <List.Item>{renderEventCard(item)}</List.Item>}
          />
        </TabPane>
        <TabPane
          tab={<div style={{ width: '100%', textAlign: 'center' }}>Meine</div>}
          key="mine"
        >
          <List
            dataSource={myEvents}
            renderItem={item => <List.Item>{renderEventCard(item)}</List.Item>}
          />
        </TabPane>
      </Tabs>
    </Drawer>
  );
};

export default HistorySidebar;
